/**
 * 格式化数字 1000 为 1,000
 *
 * @param num 需要格式化的数字
 * @param defaultTag 异常返回值
 */
function thousands(num: number | string, defaultTag = '-'): string {
  if (num == null || num === '') return defaultTag;

  var str = num.toString();
  var reg = str.indexOf('.') > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
  return str.replace(reg, '$1,');
}

/**
 * 保留几位小数默认是两位
 *
 * @param num 徐亚奥格式化的苏子
 * @param decimal 保留几位小数
 * @param smallest 小于多少就不用格式化。目前之格式化正整数
 * @param fixed  是否需要修正 1.00 为 1
 */
function keepDecimal(num: number, decimal = 2, smallest = 0, dontFixed = false): number | string {
  if (num === 0) return num;

  if (Math.abs(num) <= smallest) return num > 0 ? smallest : smallest * -1;

  // 字符串转成数字防止出现1.00这样的情况
  return dontFixed ? num.toFixed(decimal) : +num.toFixed(decimal);
}

/**
 * 判断是否为数字或者数字字符串
 *
 * @param num
 */
function isNumber(num: number | string): boolean {
  if (num == null) return false;

  if (typeof num === 'string') {
    num = num.trim();
    if (num === '') return false;

    if (isNaN(+num)) return false;

    num = +num;
  }

  if (typeof num !== 'number') return false;

  if (isNaN(num)) return false;

  return true;
}

/**
 * 格式化价格默认保留两位小数
 *
 * @param number
 * @param defaultTag
 * @param unit 单位
 * @param suffix
 */
function formatPrice(number: string | number, defaultTag = '-', unit = 1, suffix = ''): string {
  const res = formatNumber(
    number,
    defaultTag,
    {
      decial: 2,
      smallest: 0.01,
    },
    true,
    (val) => val / unit
  );
  return res === defaultTag ? defaultTag : res + suffix;
}

/**
 * 查找字符串末尾非数字的字符
 *
 * @param str
 */
function _matchNumFromStr(str: string) {
  const reg = /^(-?\d+\.?\d*)(\D+)?$/;
  const matchRes = str.match(reg);

  return matchRes;
}
/**
 * 格式化有后缀的数字 1000.111% 为 1,000.11%，后缀可以自定义
 *
 * @param str 需要格式化的数字或者字符串
 * @param defaultTag 不合法入参默认返回值
 * @param suffix 后缀
 */
function formatNumEndWithStr(str: string | number, defaultTag = '-', suffix?: string): string {
  if (str == null) return defaultTag;
  if (typeof str === 'string') str = str.trim();
  else str = str.toString();
  const matchRes = _matchNumFromStr(str);

  suffix = suffix || (matchRes && matchRes[2]) || '';

  return (
    formatNumber(
      (matchRes && matchRes[1]) || '',
      defaultTag,
      {
        decial: 2,
        smallest: 0.01,
      },
      true
    ) + suffix
  );
}

interface decialObjectOption {
  decial?: number;
  smallest?: number;
  dontFixed?: boolean;
  fixed?: boolean;
}

type decialOption = number | decialObjectOption;

/**
 * 格式化数字
 *
 * @param number
 * @param defaultValue
 * @param decimal
 * @param needthousands
 * @param isValCb
 */
function formatNumber(
  number: string | number,
  defaultValue = '-',
  decimal: decialOption = 2 /* 保留几位小数 */,
  needthousands: boolean /* 是否需要千分位 */,
  isValCb = (val: number) => val /* 分母 */
) {
  // console.log(number, isNumber(number))
  if (!isNumber(number)) return defaultValue;

  number = isValCb(+number);

  if (decimal != null) {
    if (typeof decimal === 'object') {
      const { decial: _decimal, smallest = 0.01, fixed, dontFixed } = decimal;
      number = keepDecimal(number, _decimal, smallest, fixed || dontFixed);
    } else {
      number = keepDecimal(number, decimal, 0.01);
    }
  }

  if (needthousands != null) {
    number = thousands(number);
  }

  return number;
}

/**
 * 搜索格式化价格，默认保留两位小数
 *
 * @param number
 * @param defaultTag
 * @param unit 单位
 * @param suffix
 * @param decial
 */
function formatSearchPrice(number: string | number, defaultTag = '--', unit = 1, suffix = '', decial = 2): string {
  const res = formatNumber(
    number,
    defaultTag,
    {
      decial: decial,
      smallest: 0.01,
    },
    true,
    (val) => val / unit
  );
  return res === defaultTag ? defaultTag : res + suffix;
}

export default formatNumber;

export { thousands, keepDecimal, formatSearchPrice, isNumber, formatNumber, formatPrice, formatNumEndWithStr };
